import { render, staticRenderFns } from "./veSbzcZcCategory.vue?vue&type=template&id=2df42e4c&scoped=true"
import script from "./veSbzcZcCategory.vue?vue&type=script&lang=js"
export * from "./veSbzcZcCategory.vue?vue&type=script&lang=js"
import style0 from "./veSbzcZcCategory.vue?vue&type=style&index=0&id=2df42e4c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df42e4c",
  null
  
)

export default component.exports